import 'css-chunksrc/client/pages/personalSpacePage/synthesis/section/styles.scss';export default {
  "section": "_section_wltcy_1",
  "heading": "_heading_wltcy_11",
  "title": "_title_wltcy_16",
  "main": "_main_wltcy_24"
};